import axios from "axios";
import { PresentationFilter } from "../utilities/presentaciones.classes";

export const getPresentacionesGeneradas = async () => {
    return axios.get('api/presentaciones/ConsultarPresentacionesGeneradas')
}

export const consultarFiltradas = async (filter: PresentationFilter) => {
    let castedStatus: string | null = filter.status != null && filter.status.length > 0 ? filter.status.map(s => s.id).toString() : null;
    let body = {idComercio: 0, from: filter.from, to: filter.to, searchText: filter.text, status: castedStatus};

    return axios.post(`api/presentaciones/ConsultarFiltradas`, body);
}

export const ObtenerPresentacionComprobante = async (nombreDocumento: string) => {
    return axios.get(`api/presentaciones/ObtenerPresentacionComprobante?nombreDocumento=${nombreDocumento}`)
}

export const maximoTamanoImagen = async () => {
    return axios.get(`api/presentaciones/maximoTamanoImagen`)
}
  


